import { WidgetBase } from "../core/WidgetBase.js";

export class MultiDisplayWidget extends WidgetBase {
    static styles = `
        .multi-display-widget {
            display: flex; /* Use flexbox for layout */
            flex-wrap: wrap; /* Allow items to wrap */
            justify-content: space-around; /* Distribute items evenly */
            gap: 1rem; /* Spacing between items */
        }
        .multi-display-item {
            text-align: center;
            flex: 1 1 150px; /*  Grow, shrink, and have a basis of 150px */
            min-width: 150px; /* Minimum width for each item */
            padding: 0.5rem;
            border: 1px solid #ddd;
            border-radius: var(--ab-radius-xs);
        }
        .multi-display-item__label {
            font-size: var(--ab-text-md);
            color: #6c757d;
        }
        .multi-display-item__value {
            font-size: var(--ab-text-lg);
            font-weight: bold;
        }

        .multi-display-item__icon {
            color: var(--bs-secondary-color); /* Or var(--bs-primary) */
            font-size: var(--ab-text-md); /* Adjust as needed */
        }
        .multi-display-item__label {
            display: flex; /* To align icon and text */
            align-items: center;
            justify-content: center; /* Center label content */
            font-size: var(--ab-text-base); /* Slightly smaller label */
            color: var(--bs-secondary-color);
            margin-bottom: 0.25rem;
        }
        .multi-display-item__value {
            font-size: var(--ab-text-lg); /* Slightly smaller value */
            font-weight: 500; /* Less bold */
        }

    `;

    constructor(config) {
        if (!config.widget.size) config.widget.size = "large";
        super(config);
        this.applyStyles();
    }


    renderContent() {
        if (this.error) {
            this.contentContainer.innerHTML = `<div class="widget-error">Error: ${this.error.message}</div>`;
            return;
        }

        if (this.isLoading) { return; }

        const mainData = this.data?.main; // <-- **THE FIX IS HERE**

        if (!mainData || typeof mainData !== 'object' || Object.keys(mainData).length === 0) {
            this.contentContainer.innerHTML = `<div class="data-widget-no-data">${this.t(this.config.widget.noDataMessage || 'No data available.')}</div>`;
            this.appClient.tx.applyTranslations(this.contentContainer);
            return;
        }

        const container = document.createElement("div");
        container.className = "multi-display-widget";

        this.config.widget.items.forEach(itemConfig => {
            const itemValue = mainData[itemConfig.valueField];
            let formattedValue = (itemValue === undefined || itemValue === null) ? '-' : itemValue;

            if (itemConfig.format && (itemValue !== undefined && itemValue !== null)) {
                if (itemConfig.format === 'currency') {
                    formattedValue = new Intl.NumberFormat(this.appClient.tx.getCurrentLanguage() || 'en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 4 }).format(itemValue);
                } else if (itemConfig.format === 'percentage') {
                    formattedValue = new Intl.NumberFormat(this.appClient.tx.getCurrentLanguage() || 'en-US', { style: 'percent', maximumFractionDigits: 2 }).format(itemValue);
                } else if (itemConfig.format === 'number') {
                    formattedValue = new Intl.NumberFormat(this.appClient.tx.getCurrentLanguage() || 'en-US').format(itemValue);
                } else if (typeof itemConfig.format === 'function') {
                    formattedValue = itemConfig.format(itemValue, this.data);
                }
            }

            const itemElement = document.createElement("div");
            itemElement.className = "multi-display-item";
            let iconHtml = itemConfig.icon ? `<i class="multi-display-item__icon ${itemConfig.icon} me-2"></i>` : '';
            itemElement.innerHTML = `<div class="multi-display-item__label" data-i18n="${itemConfig.label}">${iconHtml}${this.t(itemConfig.label)}</div><div class="multi-display-item__value">${formattedValue}</div>`;
            container.appendChild(itemElement);
        });

        this.contentContainer.innerHTML = '';
        this.contentContainer.appendChild(container);
        this.appClient.tx.applyTranslations(this.contentContainer);
    }
}